export const gender = {
  M: "Male",
  F: "Female",
  U: "Unknown",
};
export const category={
    GEN: "GENERAL",
    OTH: "OTHERS",
}

//source enums
export const REFUND_MANAGE_ACCOUNTS = 'refund_manage_accounts';
export const STUDENT_OUTSTANDING_DETAILS = 'student_outstanding_details';
